import React from 'react';
import './pages/citypower/styles.scss';
import {
  Switch, Route, Redirect, useLocation,
} from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Dimmer, Loader } from 'semantic-ui-react';
import { Context } from './functions/citypower/context';
import { PortalNav } from './components/citypower/header';
import { Login } from './pages/citypower/login';
import { HomePage } from './pages/citypower/HomePage';
import {
  LogFaultMyAddress,
  LogFaultOtherAddress,
} from './pages/citypower/LogFault';
import { ProfileForm, RegistrationForm } from './pages/citypower/profile';
import { OpenFaults } from './pages/citypower/openFaults';
import { AllFaults } from './pages/citypower/allFaults';
import { Notifications } from './pages/citypower/notifications';
import { CityPowerAppContainer, Footer } from './pages/citypower/citypowerpage.styled';

export class CityPowerApp extends React.Component {
  static contextType = Context;

  constructor(props) {
    super(props);
    this.state = { openSnackbar: true };
  }

  // componentDidMount() {
  //   setTimeout(
  //     () => document.getElementById('App').scrollTo(0, 0),
  //     0,
  //   );
  // }

  // componentDidUpdate() {
  //   setTimeout(
  //     () => document.getElementById('App').scrollTo(0, 0),
  //     0,
  //   );
  // }

  snackbarClose = (e, reason) => {
    if (reason === 'clickaway') return;
    this.setState({ openSnackbar: false });
  };

  render() {
    document.title = 'City Power Portal';
    const { openSnackbar } = this.state;
    const {
      authenticated,
      logout,
      cookies: { cookies },
    } = this.context;
    console.log('Authenticated:', authenticated);

    if (authenticated === null) {
      return (
        <Dimmer inverted active>
          <Loader />
        </Dimmer>
      );
    }

    const portalNavPaths = [
      '/profile',
      '/notifications',
      '/logFaultMyAddress',
      '/logFaultOtherAddress',
      '/openFaults',
      '/allFaults',
    ];

    const pagesPaths = [
      ['/profile', <ProfileForm />],
      ['/logFaultMyAddress', <LogFaultMyAddress />],
      ['/logFaultOtherAddress', <LogFaultOtherAddress />],
      ['/openFaults', <OpenFaults />],
      ['/allFaults', <AllFaults />],
      ['/notifications', <Notifications />],
    ];

    return (
      <CityPowerAppContainer
        id="CityPowerApp"
      >
        <Switch>
          {portalNavPaths.map((path, i) => (
            <Route path={path} key={i}>
              <PortalNav />
            </Route>
          ))}
        </Switch>
        <div id="App">
          <Container fluid id="AppContainer">
            <Switch>
              <Route
                path="/login"
                render={({ location }) => (!authenticated ? (
                  <Login />
                ) : (
                  <Redirect
                    to={{ pathname: '/home', state: { from: location } }}
                  />
                ))}
              />
              <Route
                path="/register"
                render={({ location }) => (!authenticated ? (
                  <RegistrationForm />
                ) : (
                  <Redirect
                    to={{ pathname: '/home', state: { from: location } }}
                  />
                ))}
              />
              {!authenticated && (
                <Route
                  path="/"
                  render={({ location }) => (
                    <Redirect
                      to={{ pathname: '/login', state: { from: location } }}
                    />
                  )}
                />
              )}
              <Route
                exact
                path="/"
                render={({ location }) => (
                  <Redirect
                    to={{ pathname: '/home', state: { from: location } }}
                  />
                )}
              />
              <Route
                path="/home"
                render={({ location }) => (authenticated ? (
                  <HomePage />
                ) : (
                  <Redirect
                    to={{ pathname: '/login', state: { from: location } }}
                  />
                ))}
              />
              <Route
                path="/logout"
                render={() => {
                  logout();
                }}
              />
              {pagesPaths.map(([path, page], i) => (
                <Route path={path} key={i}>
                  {page}
                </Route>
              ))}
              <Route path="*">
                <NoMatch />
              </Route>
            </Switch>
          </Container>
        </div>
        <Route path="/">
          <Footer>
            <div
              style={{ paddingRight: '5px' }}
              className="link"
              role="button"
              tabIndex={0}
              onClick={() => {
                window.open('https://www.forcelink.net');
              }}
            >
              Powered by Forcelink&trade; 2023 |
            </div>
            <div
              className="link"
              role="button"
              tabIndex={0}
              onClick={() => {
                window.open('https://www.forcelink.net/privacy-policy');
              }}
            >
              Privacy Policy
            </div>
          </Footer>
        </Route>
        {cookies.SESSION != null
          && cookies.username != null
          && cookies.username !== '' && (
            <Snackbar
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              open={openSnackbar}
              autoHideDuration={6000}
              onClose={this.snackbarClose}
            >
              <Alert
                onClose={this.snackbarClose}
                severity="info"
                elevation={6}
                variant="filled"
              >
                Logged in with username
                {' '}
                <b>{cookies.username}</b>
              </Alert>
            </Snackbar>
        )}
      </CityPowerAppContainer>
    );
  }
}

const NoMatch = () => {
  document.title = '404 Not Found | City Power';
  const location = useLocation();
  return (
    <div>
      <h3>
        404: There doesn&apos;t seem to be a page titled
        {' '}
        <code>{location.pathname}</code>
      </h3>
    </div>
  );
};
